import { render, staticRenderFns } from "./registerInfo.vue?vue&type=template&id=001b5ff5&scoped=true&"
import script from "./registerInfo.vue?vue&type=script&lang=js&"
export * from "./registerInfo.vue?vue&type=script&lang=js&"
import style0 from "./registerInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./registerInfo.vue?vue&type=style&index=1&id=001b5ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b5ff5",
  null
  
)

export default component.exports